import {FilterAccountStatus, FilterState} from "../types";
import {Reducer} from "redux";
import {UserAdminActionTypes} from "../actionTypes";
import { OrderFilterEnum } from '../../OrderFilterEnum';
import { initializeRoles, initializeUsers } from "../routines";


const filterState: FilterState = {
  search: "",
  customer: [],
  role: [],
  status: FilterAccountStatus.ACTIVE,
  orderFilter: OrderFilterEnum.ALPHABETICAL
};

const filter: Reducer<FilterState> = (state = filterState, action) => {
  switch (action.type) {

    case UserAdminActionTypes.SET_FILTERS:
      return{
        ...state,
        ...action.payload
      }

    case UserAdminActionTypes.FILTER_SEARCH:
      const searchState = {
        ...state,
        search: action.payload
      }
      return searchState
    case UserAdminActionTypes.FILTER_ROLE:
      
      const roleState ={
        ...state,
        role: action.payload
      }
      return roleState
    case UserAdminActionTypes.FILTER_CUSTOMER:
      const customerState = {
        ...state,
        customer: action.payload
      }
      return customerState
    case UserAdminActionTypes.FILTER_STATUS:
      const statusState = {
        ...state,
        status: action.payload
      }
      return statusState
    case UserAdminActionTypes.FILTER_ORDER:
      const orderState = {
        ...state,
        orderFilter: action.payload
      }
      return orderState

    case initializeRoles.SUCCESS: {
      return {
        ...state,
        role: action.payload.clearFilter ? [] : state.role
      }
    }

    case initializeUsers.SUCCESS: {
      return {
        ...state,
        customer: action.payload.clearFilter ? [] : state.customer
      }
    }

    default:
      return state;
  }
};

export default filter;
